import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import AddMyAddress from "../../UserProfileOverview/MyAddress/AddMyAddress/AddMyAddress";
import { getImageUrl } from "../../../../lib/get-image";
import styles from "./checkoutpayment.module.css";
import PaymentSection from "./PaymentSection";
import { useAddOrderMutation } from "../../../../queries/useOrderQuery";
import { useRemoveCartItem } from "../../../../queries/useCartQuery";
import { paymentOptions } from "../../../../constants/payment-options";
import { useUserAddressListQuery } from "../../../../queries/useUserAddress";
import {
  CART,
  USER_ORDERS,
} from "../../../../constants/query.constants";

import {
  payWithRazorpay,
  razorpayPaymentFailed,
  verifyRazorpayPayment,
} from "../../../../repositories/orders/orderRepository";
import CheckoutStepper from "../../Cart/Checkoutstepper";



const CheckoutPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
const {
  data: addressList = [],
  isPending: isPendingAddress,
} = useUserAddressListQuery();
  const [prescriptions, setPrescriptions] = useState({});

  const [selectedPayment, setSelectedPayment] = useState(null);
  const [storedAddress, setStoredAddress] = useState(null);
  const [savedShipping, setSavedShipping] = useState(null);
const [showAddressEdit, setShowAddressEdit] = useState(false);
  // =====================================================
  // SAFE DISPLAY VALUE
  // Prevents "Objects are not valid as a React child"
  // =====================================================
  const getDisplayValue = (value) => {
    if (value == null) return "";

    if (typeof value === "object") {
      return (
        value.name ||
        value.title ||
        value.label ||
        value.value ||
        ""
      );
    }

    return String(value);
  };

  // =====================================================
  // LOAD PRESCRIPTIONS
  // =====================================================
  // useEffect(() => {
  //   try {
  //     const stored = localStorage.getItem("productPrescriptions");

  //     if (!stored) return;

  //     const parsed = JSON.parse(stored);
  //     const rebuilt = {};

  //     Object.entries(parsed).forEach(([productId, files]) => {
  //       rebuilt[productId] = files.map((f) => {
  //         const arr = f.base64.split(",");
  //         const mime = f.type;

  //         const bstr = atob(arr[1]);
  //         let n = bstr.length;

  //         const u8arr = new Uint8Array(n);

  //         while (n--) {
  //           u8arr[n] = bstr.charCodeAt(n);
  //         }

  //         return {
  //           file: new File([u8arr], f.name, {
  //             type: mime,
  //           }),
  //         };
  //       });
  //     });

  //     setPrescriptions(rebuilt);
  //   } catch (error) {
  //     console.error("Prescription loading error:", error);
  //   }
  // }, []);

  // =====================================================
  // LOAD CHECKOUT DATA
  // =====================================================
// =====================================================
// LOAD CHECKOUT DATA
// ONLY ACCEPT ADDRESS FROM CURRENT ADDRESS LIST
// =====================================================
// =====================================================
// LOAD CHECKOUT DATA
// FLOW: CART -> PAYMENT
// =====================================================
useEffect(() => {
  try {
    const storedAddress =
      localStorage.getItem("checkoutAddress");

    const storedShipping =
      localStorage.getItem("shipping-rules");

    const address = storedAddress
      ? JSON.parse(storedAddress)
      : null;

    const shipping = storedShipping
      ? JSON.parse(storedShipping)
      : null;

    // ==========================================
    // SHIPPING
    // ==========================================
    if (!shipping) {
      toast.error("Shipping data missing");
      navigate("/cart");
      return;
    }

    setSavedShipping(shipping);

    // ==========================================
    // ADDRESS NOT AVAILABLE
    // GO BACK TO CART
    // ==========================================
    if (!address) {
      console.log("NO CHECKOUT ADDRESS");

      localStorage.removeItem("checkoutAddress");

      setStoredAddress(null);

      toast.error("Please select a delivery address");

      navigate("/cart");

      return;
    }

    // ==========================================
    // ADDRESS ID MISSING
    // GO BACK TO CART
    // ==========================================
    if (!address.id) {
      console.log(
        "INVALID CHECKOUT ADDRESS - NO ID"
      );

      localStorage.removeItem("checkoutAddress");

      setStoredAddress(null);

      toast.error("Please select a valid delivery address");

      navigate("/cart");

      return;
    }

    // ==========================================
    // CHECK ADDRESS AGAINST CURRENT ADDRESS LIST
    // ==========================================
    const validAddress = addressList.find(
      (item) =>
        String(item.id) === String(address.id)
    );

    // ==========================================
    // OLD ADDRESS / DELETED ADDRESS
    // GO BACK TO CART
    // ==========================================
    if (!validAddress) {
      console.log(
        "OLD ADDRESS FOUND:",
        address
      );

      console.log(
        "CURRENT ADDRESS LIST:",
        addressList
      );

      localStorage.removeItem("checkoutAddress");

      setStoredAddress(null);

      toast.error(
        "Selected address is no longer available"
      );

      navigate("/cart");

      return;
    }

    // ==========================================
    // USE CURRENT ADDRESS FROM API
    // ==========================================
    setStoredAddress(validAddress);

    console.log(
      "CURRENT VALID ADDRESS:",
      validAddress
    );

  } catch (error) {
    console.error(
      "Checkout data error:",
      error
    );

    localStorage.removeItem("checkoutAddress");

    setStoredAddress(null);

    toast.error("Invalid checkout data");

    navigate("/cart");
  }
}, [
  addressList,
  navigate,
]);
// =====================================================
// EDIT DELIVERY ADDRESS
// =====================================================

const handleEditAddress = () => {
  setShowAddressEdit(true);
};

const handleCloseAddressEdit = () => {
  setShowAddressEdit(false);
};

const handleAddressUpdate = (response) => {
  console.log("UPDATED ADDRESS:", response);

  const updatedAddress =
    response?.data || response;

  if (!updatedAddress) {
    toast.error("Address updated but data not found");
    return;
  }

  // Update only React state
  setStoredAddress(updatedAddress);

  // Do NOT save address to localStorage
  localStorage.removeItem("checkoutAddress");

  setShowAddressEdit(false);

  toast.success("Address updated successfully");
};
  // =====================================================
  // BUY NOW ITEM
  // =====================================================
  const buyNowItem = location.state?.buyNow
    ? [
        {
          id: location.state.product.id,
          quantity: location.state.quantity,
          product: location.state.product,
        },
      ]
    : null;

  // =====================================================
  // SELECTED CART ITEMS
  // =====================================================
  let selectedCartItems = [];

  try {
    selectedCartItems = buyNowItem
      ? buyNowItem
      : JSON.parse(
          localStorage.getItem("selectedCheckoutItems")
        ) || [];
  } catch (error) {
    console.error(
      "Selected checkout items parsing error:",
      error
    );

    selectedCartItems = [];
  }

  const selectedCount = selectedCartItems.length;

  // =====================================================
  // SUBTOTAL
  // =====================================================
  const subtotal = selectedCartItems.reduce((acc, item) => {
    const price = Number(
      item.product?.offer_price > 0
        ? item.product.offer_price
        : item.product?.price ||
            item.price ||
            item.unit_price ||
            0
    );

    return acc + price * Number(item.quantity || 1);
  }, 0);

  // =====================================================
  // TOTAL QUANTITY
  // =====================================================
  const totalQty = selectedCartItems.reduce(
    (acc, item) =>
      acc + Number(item.quantity || item.qty || 1),
    0
  );

  // =====================================================
  // SHIPPING
  // =====================================================
  const shipping = Number(
    typeof savedShipping?.cost === "object"
      ? savedShipping?.cost?.amount ||
          savedShipping?.cost?.value ||
          0
      : savedShipping?.cost || 0
  );

  const tax = 0;

  const total = subtotal + shipping;

  const isCartPending = false;

  // =====================================================
  // ORDER SUMMARY
  // =====================================================
  const orderSummary = {
    subtotal,
    shipping,
    tax,
    total,
    totalQty,
  };

  // =====================================================
  // MUTATIONS
  // =====================================================
  const {
    mutateAsync: placeOrder,
    isPending: isOrderPlacePending,
  } = useAddOrderMutation();

  const { mutateAsync: removeCartItem } =
    useRemoveCartItem();

  // =====================================================
  // CLEAR CART
  // =====================================================
  const clearCart = async () => {
    if (buyNowItem) return;

    for (const item of selectedCartItems) {
      await removeCartItem(item.id);
    }

    queryClient.invalidateQueries({
      queryKey: [CART],
    });

    queryClient.invalidateQueries({
      queryKey: [USER_ORDERS],
    });
  };

  // =====================================================
  // PLACE ORDER
  // =====================================================
  const handlePlaceOrder = async () => {
    if (!selectedPayment) {
      toast.error("Select payment method!");
      return;
    }

   

    try {
      // =================================================
      // BASIC PAYLOAD FOR RAZORPAY
      // =================================================
      const payload = {
        sub_total: Number(subtotal),
        amount: Number(total),
        product_qty: Number(totalQty),

        order_address: storedAddress,

        shipping_method: savedShipping,

        products: selectedCartItems.map((item) => ({
          product_id:
            item.product_id ||
            item.product?.id ||
            null,

          vendor_id:
            item.vendor_id ||
            item.product?.vendor_id ||
            null,

          product_name:
            getDisplayValue(
              item.product_name ||
                item.product?.name ||
                item.name
            ) || "",

          unit_price: Number(
            item.price ||
              item.unit_price ||
              item.product?.offer_price ||
              item.product?.price ||
              0
          ),

          qty: Number(
            item.quantity ||
              item.qty ||
              1
          ),
        })),
      };

      // =================================================
      // FORMDATA
      // =================================================
      const formData = new FormData();

      // =================================================
      // BASIC
      // =================================================
      formData.append(
        "sub_total",
        String(Number(subtotal || 0))
      );

      formData.append(
        "amount",
        String(Number(total || 0))
      );

      formData.append(
        "product_qty",
        String(Number(totalQty || 0))
      );

      // =================================================
      // ORDER ADDRESS
      // =================================================
      Object.entries(storedAddress || {}).forEach(
        ([key, value]) => {
          let formattedValue = value;

          if (
            typeof value === "object" &&
            value !== null
          ) {
            /*
             * If city/state/country is an object,
             * send the ID if available.
             *
             * Example:
             * city: {
             *   id: 10,
             *   name: "Hyderabad"
             * }
             *
             * Backend receives:
             * city = 10
             */
            formattedValue =
              value.id ??
              value.name ??
              "";
          }

          formData.append(
            `order_address[${key}]`,
            String(formattedValue ?? "")
          );
        }
      );

      // =================================================
      // SHIPPING
      // =================================================
      Object.entries(savedShipping || {}).forEach(
        ([key, value]) => {
          let formattedValue = value;

          if (
            typeof value === "object" &&
            value !== null
          ) {
            formattedValue =
              value.id ??
              value.name ??
              value.amount ??
              "";
          }

          formData.append(
            `shipping_method[${key}]`,
            String(formattedValue ?? "")
          );
        }
      );

      // =================================================
      // PRODUCTS
      // =================================================
      selectedCartItems.forEach((item, index) => {
        const productId =
          item.product_id ||
          item.product?.id ||
          "";

        const vendorId =
          item.vendor_id ||
          item.product?.vendor_id ||
          "";

        const productName =
          getDisplayValue(
            item.product_name ||
              item.product?.name ||
              item.name
          ) || "Product";

        const unitPrice = Number(
          item.price ||
            item.unit_price ||
            item.product?.offer_price ||
            item.product?.price ||
            0
        );

        const quantity = Number(
          item.quantity ||
            item.qty ||
            1
        );

        console.log("🛒 ITEM:", item);
        console.log("✅ PRODUCT ID:", productId);
        console.log("✅ VENDOR ID:", vendorId);

        if (!vendorId) {
          throw new Error(
            `Vendor ID missing for product: ${productName}`
          );
        }

        formData.append(
          `products[${index}][product_id]`,
          String(productId)
        );

        formData.append(
          `products[${index}][vendor_id]`,
          String(vendorId)
        );

        formData.append(
          `products[${index}][product_name]`,
          productName
        );

        formData.append(
          `products[${index}][unit_price]`,
          String(unitPrice)
        );

        formData.append(
          `products[${index}][qty]`,
          String(quantity)
        );
      });

      // =================================================
      // PRESCRIPTION IMAGE
      // =================================================
      Object.entries(prescriptions).forEach(
        ([productId, files]) => {
          files.forEach((fileObj, index) => {
            formData.append(
              `prescriptions[${productId}][${index}]`,
              fileObj.file
            );
          });
        }
      );

      // =================================================
      // RAZORPAY
      // =================================================
      if (selectedPayment === "razorpay") {
       

        const res = await payWithRazorpay(payload);

        if (!res?.order || !res?.key) {
          toast.error(
            "Razorpay order creation failed"
          );
          return;
        }

        const { order, key } = res;

        const options = {
          key,

          amount: order.amount,

          currency: order.currency,

          name: "Your Store",

          description: "Order Payment",

          order_id: order.id,

          handler: async (paymentResponse) => {
            try {
            

              const verifyRes =
                await verifyRazorpayPayment({
                  razorpay_payment_id:
                    paymentResponse.razorpay_payment_id,

                  razorpay_order_id:
                    paymentResponse.razorpay_order_id,

                  razorpay_signature:
                    paymentResponse.razorpay_signature,
                });

              console.log(
                "VERIFY RESPONSE:",
                verifyRes
              );

              toast.success(
                "Payment successful 🎉"
              );

              navigate(
                "/checkout/order-success",
                {
                  state: {
                    payment_id:
                      paymentResponse.razorpay_payment_id,

                    payment_method: "Razorpay",

                    orderId: order?.id,

                    invoice_id:
                      order?.invoice_id,
                  },
                }
              );
            } catch (err) {
              console.error(
                "Payment verification error:",
                err
              );

            

              toast.error(
                "Payment verification failed"
              );
            }
          },

          modal: {
            ondismiss: async () => {
              console.log(
                "RAZORPAY POPUP CLOSED"
              );

              try {
                const res =
                  await razorpayPaymentFailed({
                    razorpay_order_id:
                      order.id,

                    reason:
                      "cancelled_by_user",
                  });

                console.log(
                  "FAILURE API RESPONSE:",
                  res
                );
              } catch (err) {
                console.error(
                  "FAILURE API ERROR:",
                  err
                );
              }

              toast.error(
                "Payment cancelled"
              );
            },
          },

          prefill: {
            name: getDisplayValue(
              storedAddress?.name ||
                storedAddress?.full_name
            ),

            email: getDisplayValue(
              storedAddress?.email
            ),

            contact: getDisplayValue(
              storedAddress?.phone
            ),
          },

          theme: {
            color: "#3399cc",
          },
        };

        const razor =
          new window.Razorpay(options);

        razor.on(
          "payment.failed",
          async (response) => {
            console.log(
              "PAYMENT FAILED EVENT",
              response
            );

            try {
              const res =
                await razorpayPaymentFailed({
                  razorpay_order_id:
                    order.id,

                  razorpay_payment_id:
                    response?.error
                      ?.metadata
                      ?.payment_id ||
                    null,

                  reason:
                    response?.error
                      ?.description ||
                    "payment_failed",
                });

              console.log(
                "FAILURE API RESPONSE:",
                res
              );
            } catch (err) {
              console.error(
                "FAILURE API ERROR:",
                err
              );
            }
          }
        );

        razor.open();

        return;
      }

      // =================================================
      // CASH ON DELIVERY
      // =================================================
      if (selectedPayment === "cod") {
        const response =
          await placeOrder(formData);

        const invoiceId =
          response?.order?.invoice_id;

        const orderId =
          response?.order?.id;

        await clearCart();

        toast.success(
          "COD order placed successfully 🎉"
        );

        navigate(
          "/checkout/success",
          {
            state: {
              invoiceId,
              orderId,
            },
          }
        );

        return;
      }
    } catch (err) {
      console.log(
        "🔥 FULL ERROR:",
        err
      );

      console.log(
        "🔥 STATUS:",
        err?.response?.status
      );

      console.log(
        "🔥 DATA:",
        err?.response?.data
      );

      console.log(
        "🔥 MESSAGE:",
        err?.message
      );

     

      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Order failed"
      );
    }
  };

  // =====================================================
  // LOADING
  // =====================================================
  if (
    !storedAddress ||
    !savedShipping
  ) {
    return null;
  }

 

  // =====================================================
  // UI
  // =====================================================
  return (
    <section className={styles.wrapper}> 
    {/* =================================================
    EDIT DELIVERY ADDRESS POPUP
================================================= */}

{showAddressEdit && storedAddress && (
  <div className={styles.addressEditOverlay}>
    <div className={styles.addressEditPopup}>

      <AddMyAddress
        mode="edit"
        initialData={storedAddress}
        addressId={storedAddress?.id}
        onClose={handleCloseAddressEdit}
        onSave={handleAddressUpdate}
      />

    </div>
  </div>
)}
    {/* =================================================
    CHECKOUT STEPPER
================================================= */}
<div className={styles.checkoutHeader}>
  <div className={styles.bannerContent}>
    <span className={styles.bannerSmallText}>
      CHECKOUT
    </span>

    <h1>Payment</h1>

    <p>
      Review your order and choose your preferred payment
      method to complete your purchase.
    </p>
  </div>

<CheckoutStepper currentStep={2} />
</div>
      <div
        className={
          styles.contentContainer
        }
      > 
        {/* =================================================
            LEFT COLUMN
        ================================================= */}
        <div className={styles.leftColumn}>
          {/* =================================================
              PAYMENT METHOD
          ================================================= */}
          <div className={styles.paymentCard}>
            <div
              className={
                styles.cardHeader
              }
            >
              <div>
                <span
                  className={
                    styles.sectionNumber
                  }
                ></span>

                <h2>
                  Payment Method
                </h2>
              </div>

              <span
                className={
                  styles.secureBadge
                }
              >
                🔒 Secure
              </span>
            </div>

            <p
              className={
                styles.cardDescription
              }
            >
              Choose your preferred
              payment method to
              complete your order.
            </p>

            <PaymentSection
              paymentOptions={
                paymentOptions
              }
              selectedPayment={
                selectedPayment
              }
              setSelectedPayment={
                setSelectedPayment
              }
            />
          </div>

          {/* =================================================
              ORDER REVIEW
          ================================================= */}
          <div className={styles.reviewCard}>
            <div
              className={
                styles.cardHeader
              }
            >
              <div>
                <span
                  className={
                    styles.sectionNumber
                  }
                ></span>

                <h2>
                  Order Review
                </h2>
              </div>

              {/* <button
                type="button"
                className={
                  styles.editButton
                }
                onClick={() =>
                  navigate("/cart")
                }
              >
                Edit
              </button> */}
            </div>

            {/* =================================================
                DELIVERY ADDRESS
            ================================================= */}
            <div
              className={
                styles.reviewBlock
              }
            >
              <div
                className={
                  styles.reviewBlockHeader
                }
              >
                <h3>
                  Deliver to
                </h3>

               <button
  type="button"
  className={styles.smallEditButton}
  onClick={handleEditAddress}
>
  Edit
</button>
              </div>

              <div
                className={
                  styles.addressReview
                }
              >
                <strong>
                  {getDisplayValue(
                    storedAddress?.type ||
                      storedAddress?.address_type
                  ) ||
                    "Delivery Address"}
                </strong>

                <p>
                  {getDisplayValue(
                    storedAddress?.name ||
                      storedAddress?.full_name
                  )}
                </p>

                <p>
                  {getDisplayValue(
                    storedAddress?.address ||
                      storedAddress?.address_line1
                  )}
                </p>

                {/* ===============================
                    IMPORTANT FIX
                =============================== */}
                <p>
                  {getDisplayValue(
                    storedAddress?.city
                  )}

                  {storedAddress?.city &&
                  storedAddress?.state
                    ? ", "
                    : ""}

                  {getDisplayValue(
                    storedAddress?.state
                  )}
                </p>

                <p>
                  {getDisplayValue(
                    storedAddress?.pincode ||
                      storedAddress?.postal_code
                  )}
                </p>

                {storedAddress?.phone && (
                  <p>
                    Phone:{" "}
                    {getDisplayValue(
                      storedAddress.phone
                    )}
                  </p>
                )}
              </div>
            </div>

            {/* =================================================
                SHIPPING METHOD
            ================================================= */}
            <div
              className={
                styles.reviewBlock
              }
            >
              <div
                className={
                  styles.reviewBlockHeader
                }
              >
                <h3>
                  Shipping Method
                </h3>

                {/* <button
                  type="button"
                  className={
                    styles.smallEditButton
                  }
                  onClick={() =>
                    navigate("/cart")
                  }
                >
                  Edit
                </button> */}
              </div>

              <div
                className={
                  styles.shippingReview
                }
              >
                <div
                  className={
                    styles.shippingIcon
                  }
                >
                  🚚
                </div>

                <div
                  className={
                    styles.shippingDetails
                  }
                >
                  <strong>
                    {getDisplayValue(
                      savedShipping?.name ||
                        savedShipping?.title ||
                        savedShipping?.shipping_name
                    ) ||
                      "Standard Delivery"}
                  </strong>

                  <span>
                    {getDisplayValue(
                      savedShipping?.description ||
                        savedShipping?.delivery_time
                    ) ||
                      "3–5 business days"}
                  </span>
                </div>

                <strong
                  className={
                    styles.shippingPrice
                  }
                >
                  {shipping === 0
                    ? "FREE"
                    : `₹${shipping}`}
                </strong>
              </div>
            </div>

            {/* =================================================
                ITEMS
            ================================================= */}
            <div
              className={
                styles.reviewBlock
              }
            >
              {/* <div
                className={
                  styles.reviewBlockHeader
                }
              >
                <h3>
                  Items (
                  {selectedCartItems.length}
                  )
                </h3>
              </div> */}

              <div
                className={
                  styles.reviewItems
                }
              >
                {selectedCartItems.map(
                  (item, index) => {
                    const product =
                      item.product || {};

                    const productName =
                      getDisplayValue(
                        item.product_name ||
                          product.name ||
                          item.name
                      ) || "Product";

                    const image =
                      product.thumb_image ||
                      product.image ||
                      product.thumbnail ||
                      product.product_image ||
                      item.image ||
                      "";

                    const price = Number(
                      product.offer_price > 0
                        ? product.offer_price
                        : product.price ||
                            item.price ||
                            item.unit_price ||
                            0
                    );

                    const quantity =
                      Number(
                        item.quantity ||
                          item.qty ||
                          1
                      );

                    return (
                      <div
                        className={
                          styles.reviewItem
                        }
                        key={
                          item.id ||
                          product.id ||
                          index
                        }
                      >
                        <div
                          className={
                            styles.reviewItemImage
                          }
                        >
                          {image ? (
                            <img
                              src={getImageUrl(
                                image
                              )}
                              alt={
                                productName
                              }
                            />
                          ) : (
                            <div
                              className={
                                styles.noImage
                              }
                            >
                              🛍️
                            </div>
                          )}
                        </div>

                        <div
                          className={
                            styles.reviewItemInfo
                          }
                        >
                          <strong>
                            {
                              productName
                            }
                          </strong>

                          <span>
                            Qty:{" "}
                            {quantity}
                          </span>
                        </div>

                        <strong
                          className={
                            styles.reviewItemPrice
                          }
                        >
                          ₹
                          {(
                            price *
                            quantity
                          ).toLocaleString(
                            "en-IN"
                          )}
                        </strong>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>

        {/* =================================================
            RIGHT COLUMN - ORDER SUMMARY
        ================================================= */}
        <aside
          className={
            styles.orderSummarySection
          }
        >
          <div
            className={
              styles.summaryHeader
            }
          >
            <div>
              <h2>
                Order Summary
              </h2>

              <span>
                {selectedCount} product
                {selectedCount !== 1
                  ? "s"
                  : ""}
              </span>
            </div>
          </div>

          {/* =================================================
              PRICE DETAILS
          ================================================= */}
          <div
            className={
              styles.priceDetails
            }
          >
            <div
              className={
                styles.summaryRow
              }
            >
              <span>
                Subtotal ({totalQty}{" "}
                item
                {totalQty > 1
                  ? "s"
                  : ""})
              </span>

              <strong>
                ₹
                {subtotal.toLocaleString(
                  "en-IN"
                )}
              </strong>
            </div>

            <div
              className={
                styles.summaryRow
              }
            >
              <span>
                Shipping
              </span>

              <strong
                className={
                  styles.freeShipping
                }
              >
                {shipping === 0
                  ? "FREE"
                  : `₹${shipping.toLocaleString(
                      "en-IN"
                    )}`}
              </strong>
            </div>

            <div
              className={
                styles.summaryRow
              }
            >
              <span>
                Tax
              </span>

              <strong>
                ₹
                {tax.toLocaleString(
                  "en-IN"
                )}
              </strong>
            </div>
          </div>

          {/* =================================================
              TOTAL
          ================================================= */}
          <div
            className={
              styles.summaryTotal
            }
          >
            <span>
              Total Amount
            </span>

            <strong>
              ₹
              {total.toLocaleString(
                "en-IN"
              )}
            </strong>
          </div>

          {/* =================================================
              SAVINGS
          ================================================= */}
          {subtotal > total && (
            <div
              className={
                styles.savingsMessage
              }
            >
              🎉 You are saving ₹
              {(
                subtotal - total
              ).toLocaleString(
                "en-IN"
              )}
            </div>
          )}

          {/* =================================================
              PLACE ORDER
          ================================================= */}
          <button
            type="button"
            className={
              styles.payButton
            }
            onClick={
              handlePlaceOrder
            }
            disabled={
              isOrderPlacePending ||
              !selectedPayment
            }
          >
            {isOrderPlacePending ? (
              <>
                <span
                  className={
                    styles.btn_spinner
                  }
                ></span>

                Processing...
              </>
            ) : (
              <>
                Place Order

                <span>
                  →
                </span>
              </>
            )}
          </button>

   <p className={styles.paymentTerms}>
  By placing your order, you agree to our{" "}
  
  <button
    type="button"
    className={styles.termsLink}
    onClick={() => navigate("/terms-and-conditions")}
  >
    Terms & Conditions
  </button>{" "}
  
  and{" "}
  
  <button
    type="button"
    className={styles.termsLink}
    onClick={() => navigate("/privacy-policy")}
  >
    Privacy Policy
  </button>
  .
</p>

          {/* =================================================
              SECURITY
          ================================================= */}
          <div
            className={
              styles.securityBox
            }
          >
            <div
              className={
                styles.securityIcon
              }
            >
              🛡️
            </div>

            <div>
              <strong>
                Safe & Secure Payments
              </strong>

              <p>
                Your payment information
                is protected
              </p>
            </div>
          </div>

          {/* =================================================
              TRUST
          ================================================= */}
          <div
            className={
              styles.trustList
            }
          >
            <div
              className={
                styles.trustItem
              }
            >
              <span>
                ↩
              </span>

              <div>
                <strong>
                  Easy Returns
                </strong>

                <p>
                  7 days return policy
                </p>
              </div>
            </div>

            <div
              className={
                styles.trustItem
              }
            >
              <span>
                ◉
              </span>

              <div>
                <strong>
                  24/7 Support
                </strong>

                <p>
                  We are here to help
                </p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default CheckoutPayment;